import React from 'react';
import { slugify } from '../../../utils/helpers'

export const Textarea = (props) => {
  const { field, value, handleChange } = props
  const {type, name, placeholder, required, className } = field
  return (
    <div className={`${className}${value[slugify(name)] ? ' active' : ''}${required ? ' required' : ''}`}>
      <label htmlFor={name}>{placeholder}</label>
      <textarea name={slugify(name)} id={slugify(name)} placeholder={placeholder} required={required ? true : false} onChange={handleChange} value={value[slugify(name)]} />
    </div>
  )
}
